export enum SelfExamineActionsEnum {
    Create = '[self-examine] Create',
    CreateSuccess = '[self-examine] CreateSuccess',
    CreateFailed = '[self-examine] CreateFailed',
}
